import type { DipTone } from "~/features/dataImportProjects/types";

/** Maps a DIP statusId to a Badge tone. Unknown statuses fall back to neutral. */
const STATUS_TONE: Record<string, DipTone> = {
  Inbox: "neutral",
  Planning: "primary",
  DataInput: "primary",
  EvidenceImport: "primary",
  ERComposition: "primary",
  DataApproval: "attention",
  Done: "success",
};

export function statusTone(statusId: string): DipTone {
  return STATUS_TONE[statusId] ?? "neutral";
}
